import React from 'react';
import Slider from 'react-infinite-logo-slider';
import _ from "lodash";
import useMediaQuery from "../hooks/useMediaQuery";

const HomeCTASection = ({title, subtitle, partnerLogos, style}) => {
    const isMobile = useMediaQuery(768);
    const windowWidth = window.innerWidth;
//   const partnerLogos = [
//     { src: '/images/logos/san-jose-quakes.png', alt: 'San Jose Quakes' },
//     { src: '/images/logos/nrg.png', alt: 'NRG' },
//     { src: '/images/logos/devils.png', alt: 'Devils' },
//     { src: '/images/logos/flyquest.png', alt: 'FlyQuest' },
//     { src: '/images/logos/vegas-golden-knights.png', alt: 'Vegas Golden Knights' },
//     { src: '/images/logos/houston-rockets.png', alt: 'Houston Rockets' },
//   ];

  return (
    <div className="HomeCTASection" style={style}>
      <h1 className="HomeCTASection__title">
        {title}
      </h1>
      <h2 className="HomeCTASection__subtitle">
        {subtitle}
      </h2>
      <div className="HomeCTASection__slider">
          <Slider
              width={isMobile ? "140px" : "150px"}
              duration={((partnerLogos?.length * 10) * (Math.min(windowWidth, 1366) / 1366))}
              pauseOnHover={true}
              blurBorders={false}
              blurBorderColor={'#fff'}
          >
              {
                  _.map(partnerLogos, (partnerLogo) => {
                      return (
                          <Slider.Slide>
                              <a className={'HomeCTASection__slider-item'}
                                 href={_.isEmpty(partnerLogo.url) ? null : partnerLogo.url}
                                 target={'_blank'}
                              >
                                  <img src={`/images/logos/customers/edgecloud/${partnerLogo.logo}`}
                                       className={'CustomerLogoSlide__logo'}
                                  />
                              </a>
                          </Slider.Slide>
                      )
                  })
              }
          </Slider>
      </div>
    </div>
  );
};

export default HomeCTASection; 